import React from 'react'
import { array, func, string } from 'prop-types'
import styled from '@emotion/styled'

const Select = styled.select`
	border: 1px solid rgba(0, 0, 0, 0.2);
	color: #686868;
	display: inline-block;
	font: inherit;
	font-size: 100%;
	margin: 0.5rem 0;
	padding: 0.5em;
	padding-right: 0.25rem;
	position: relative;
	text-transform: none;
	overflow: visible;
	width: 100%;
`

const SelectContainer = styled.div`
	padding-right: 1rem;
	width: 130px;
`

const propTypes = {
	defaultSelected: string,
	handleChangeOnSelect: func.isRequired,
	id: string.isRequired,
	options: array.isRequired,
}

function Dropdown({ id, defaultSelected, handleChangeOnSelect, options }) {
	return (
		<SelectContainer>
			<Select
				id={id}
				onChange={(e) => {
					const { id, value } = e.target
					handleChangeOnSelect({ id, value })
				}}
				value={defaultSelected}
			>
				{options.map((option) => {
					const { label, value } = option
					return (
						<option key={value} value={value}>
							{label}
						</option>
					)
				})}
			</Select>
		</SelectContainer>
	)
}

Dropdown.propTypes = propTypes

export default Dropdown
